import { BuilderConfig } from '../../../types/Builder';
import { COLORS, ICONS, SIZES } from '../../business-button/business-button.constants';

import B2BListCardResources, { B2BListCardResourcesProps } from './b2b-list-card-resources';

export const B2BListCardResourcesConfig = {
    name: 'B2b List Card Resources',
    inputs: [
        {
            name: 'backgroundCard',
            type: 'color',
            defaultValue: '#E7EAED',
        },
        {
            name: 'showListNameCard',
            type: 'boolean',
        },
        {
            name: 'quantityColumnCard',
            type: 'number',
            defaultValue: 3,
        },
        {
            name: 'card',
            type: 'list',
            subFields: [
                {
                    name: 'image',
                    type: 'file',
                    defaultValue: '',
                },
                {
                    name: 'title',
                    type: 'html',
                    defaultValue: '',
                },
                {
                    name: 'description',
                    type: 'html',
                    defaultValue: '',
                },
                {
                    name: 'fontSizeDescription',
                    type: 'number',
                },
                {
                    name: 'link',
                    type: 'url',
                    defaultValue: '',
                },
                {
                    name: 'buttonText',
                    type: 'html',
                },
                {
                    name: 'iconType',
                    type: 'string',
                    enum: Object.values(ICONS),
                    defaultValue: '',
                },
            ],
        },
        {
            name: 'buttonTextSize',
            type: 'string',
            enum: Object.values(SIZES),
            defaultValue: SIZES.NORMAL,
        },
        {
            name: 'buttonBackground',
            type: 'string',
            enum: Object.values(COLORS),
            defaultValue: COLORS.MINT,
        },
        {
            name: 'buttonFullWidthMobile',
            type: 'boolean',
        },
        {
            name: 'buttonPadding',
            type: 'string',
            default: '15px 30px',
        },
        {
            name: 'buttonPaddingMobile',
            type: 'string',
            default: '',
        },
        {
            name: 'paddingContentCartMobile',
            type: 'string',
            default: '',
        },
        {
            name: 'heightImageCardMobile',
            type: 'string',
            default: '',
        },
        {
            name: 'minHeightCardMobile',
            type: 'string',
            default: '',
        },
        {
            name: 'gapListCardMobile',
            type: 'string',
            default: '',
        },
    ],
};

const builderConfig: BuilderConfig<B2BListCardResourcesProps> = {
    component: B2BListCardResources,
    config: B2BListCardResourcesConfig,
};

export default builderConfig;
